module.exports = "<mat-form-field>\n  <input matInput type=\"date\" name=\"{{name}}\" placeholder=\"{{placeholder}}\" [ngModel]=\"value\" (ngModelChange)=\"change($event)\" \n    [readonly]=\"readonly\" maxlength=\"10\" pattern=\"[0-9]{2}\\/[0-9]{2}\\/[0-9]{4}$\" min=\"1900-01-01\" max=\"2999-12-31\">\n</mat-form-field>"


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-date-text/bra-date-text.component.html
// module id = ../../../../../src/app/componentes/bra-date-text/bra-date-text.component.html
// module chunks = main